import { Grid } from "@material-ui/core";
import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	makeStyles,
} from "@material-ui/core";
import React from "react";
import { MonthPicker } from "./MonthPicker";

const useStyles = makeStyles((theme) => ({
	formControl: {
		width: "100%",
		minWidth: 200,
		backgroundColor: "#FFFFFF !important",
		"& .MuiOutlinedInput-root": {
			height: 45,
			paddingTop: "10px",
			"&.Mui-focused": {
				outline: "none",
				"& .MuiOutlinedInput-notchedOutline": {
					borderColor: "rgba(0, 0, 0, 0.23)",
					borderWidth: 1,
				},
			},
		},
		"& .MuiSelect-select:focus": {
			backgroundColor: "transparent",
		},
		"& .MuiInputLabel-outlined": {
			transform: "translate(14px, 12px) scale(1)",
			"&.MuiInputLabel-shrink": {
				transform: "translate(14px, -6px) scale(0.75)",
			},
		},
	},
	monthPicker: {
		minWidth: 150,
	},
}));

// TODO: harcode
const ASSET_OPTIONS = [
	{ id: null, name: "ALL" },
	{ id: 11, name: "EAF 1" },
	{ id: 12, name: "EAF 2" },
];

type Props = {
	onMonthChange: (month: Date | null) => void;
	onAssetChange: (assetId: number | null) => void;
	selectedMonth: Date;
	selectedAsset: number | null;
};

export const Filters: React.FC<Props> = ({
	onMonthChange,
	onAssetChange,
	selectedMonth,
	selectedAsset,
}) => {
	const classes = useStyles();

	const handleMonthChange = (date: Date | null) => {
		onMonthChange(date);
	};

	const handleAssetChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const value = event.target.value;
		const assetId = value === "null" ? null : Number(value);
		onAssetChange(assetId);
	};

	return (
		<Grid container spacing={2}>
			<Grid item>
				<div className={classes.monthPicker}>
					<MonthPicker
						label="Month"
						value={selectedMonth}
						onChange={handleMonthChange}
					/>
				</div>
			</Grid>
			<Grid item>
				<FormControl variant="outlined" className={classes.formControl}>
					<InputLabel>Asset</InputLabel>
					<Select
						value={selectedAsset === null ? "null" : selectedAsset}
						label="Asset"
						onChange={handleAssetChange}
					>
						{ASSET_OPTIONS.map((option) => (
							<MenuItem
								key={option.id ?? "all"}
								value={option.id === null ? "null" : option.id}
							>
								{option.name}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Grid>
		</Grid>
	);
};
